export const getPathname = (pathname: string, newHomes: string) => {
    const searchType = newHomes === 'only' ? 'new-homes' : 'for-sale';

    const pathRegex = /for-sale|new-homes/;

    return pathname.replace(pathRegex, searchType);
};
